// The first line of every CSV template the app hands out is a stamp naming the
// product, what the file is for, and which version of the layout it uses:
//
//   #OnHand_Template,accounts,v1
//
// It used to say #MedEx_Template. Templates already sitting in somebody's
// Downloads folder still carry the old stamp, and those files are perfectly
// valid - the columns did not change with the name. So both are accepted on the
// way in, and only the new one is ever written out. Nobody has to re-download
// anything because of a rename.

export const TEMPLATE_STAMP = '#OnHand_Template';

// Kept for as long as old downloads are plausibly still in circulation. When it
// goes, files stamped #MedEx_Template start being rejected as "not generated
// from a template", so give it a good while.
const LEGACY_STAMP = '#MedEx_Template';

const STAMPS = [TEMPLATE_STAMP, LEGACY_STAMP];

// Which stamp this line starts with, or null if it carries neither.
function matchStamp(firstLine) {
  return STAMPS.find(stamp => firstLine.startsWith(stamp)) || null;
}

export function hasTemplateStamp(firstLine) {
  return matchStamp(firstLine) !== null;
}

// True when the line is a stamp for this exact type and version, e.g.
// isTemplateStamp(line, 'referral_sources', 'v1').
export function isTemplateStamp(firstLine, type, version) {
  const parsed = parseTemplateStamp(firstLine);
  return parsed !== null && parsed.type === type && parsed.version === version;
}

// Splits a stamp into its type and version. Returns null when the line is not a
// stamp at all, which the caller reports differently from a wrong type.
export function parseTemplateStamp(firstLine) {
  const line  = (firstLine || '').trim();
  const stamp = matchStamp(line);
  if (!stamp) return null;
  const parts = line.slice(stamp.length).replace(/^,/, '').split(',');
  return {
    type:    (parts[0] || '').trim(),
    version: (parts[1] || '').trim(),
  };
}
